interface PlateLayerOptions {
  className: string;
  id?: string;
  src: string;
}

const markMissing = (plate: HTMLImageElement): void => {
  plate.dataset.missing = 'true';
  plate.removeAttribute('src');
};

export const createPlateLayer = ({
  className,
  id,
  src,
}: PlateLayerOptions): HTMLImageElement => {
  const plate = document.createElement('img');
  if (id) plate.id = id;
  plate.className = className;
  plate.alt = '';
  plate.decoding = 'async';
  plate.addEventListener('error', () => markMissing(plate), { once: true });
  plate.src = src;
  return plate;
};
